import React, { Component } from 'react'
import { Col, Divider } from 'antd';
import InfoClient from './infoClient';
import InfoOrders from './InfoOrders';
import InfoProducts from './infoProducts';
import { withTranslation } from 'react-i18next';

class detailOrder extends Component {
    render() {
        const { order } = this.props

        return (
            <Col>
                <InfoClient
                    {...this.props}
                />
                <Divider type='vertical' />
                <InfoOrders
                    {...this.props}
                />
                <Divider type='vertical' />
                {order && order.productos && order.productos.length > 0 && <InfoProducts
                    {...this.props}
                />}
            </Col>
        )
    }
}

export default (withTranslation()(detailOrder));